export default {
  sm: `
  To keep our<br> 
  environment whole<br>
  and data secure<br>
  DATA CENTER GAK<br> 
  Chuncheon  
  `,
};
